import { NgModule } from '@angular/core';
import { DeviceStateConfigPageRoutingModule } from './device-state-config-routing';

@NgModule({
  imports: [DeviceStateConfigPageRoutingModule],
})
export class DeviceStateConfigPageModule {}
